import React from 'react';
import Moment from 'moment';

import Link from 'utils/localized-link';
import Button from '@youship/components/objects/button';
import Banner from 'components/sections/banner';
import Layout from 'components/layout';
import BasicLayout from 'components/basic-layout';
import SEO from 'components/seo';
import Image from 'components/image';

import prrImage from '../../images/barra-prr.png';

const image1 = 'safy-concierge/image1.png';
const image2 = 'safy-concierge/image2.png';
const image3 = 'safy-concierge/image3.png';

const bannerImage = 'home/robot-banner-bottom2.jpg';

const bannerButtons = [
  {
    linkComponent: Link,
    linkProps: {
      to: '/contacts'
    },
    light: true,
    noArrow: true,
    small: true,
    text: 'expertise.banner.buttons.contacts'
  }
];

const SafyConciergePage = ({ pageContext: { locale } }) => (

  <Layout locale={locale}>
    <SEO title="projects.title" />
    <BasicLayout>
      <>
      <div className="">
        <a href="https://recuperarportugal.gov.pt/" target='_blank'>
          <img
                alt="PRR"
                src={prrImage}
              />
         </a>     
       </div>  
      <div>
        <p className="b-layout__center">
        Transição digital das empresas medida "VOUCHERS PARA STARTUPS - NOVOS PRODUTOS
        VERDES E DIGITAIS <br/>
        
        Youship Concierge LMD <br/>
        O presente projeto visa apostar no desenvolvimento de um projeto piloto de modo a viabilizar 
        a utilização de um robô de entregas em rotas urbanas.
        <br/>
        Investimento: 30.000,00 EUR <br/>
        </p>
      </div>
      
      <div>
        <h3>
          Objetivos e Resultados Esperados:
        </h3>
        <p>
      Ensaiar a utilização de um robô de entregas em ambiente exterior, de modo a viabilizar o seguimento e apoio aos estafetas nas entregas porta a porta.
        </p>
       </div>
       <div>
            <p>
                <a href="/projects/Cartaz-Voucher.pdf">Cartaz Operação</a>
            </p>
        </div>
    </>
    </BasicLayout>
    <Banner
      buttons={bannerButtons}
      image={bannerImage}
      title="home.banner.title"
    />

  </Layout>
);

export default SafyConciergePage;
